export default __webpack_public_path__ + "files/ab3de6729fa8a676c3bcad7450ca87bc.png";